import { useField } from 'formik';
import React, { FC } from 'react';

// Interfaces
import { FormikToggleInputProps } from '../../../models/Formik';
import FormikError from '../FormikError';

const FormikToggle: FC<FormikToggleInputProps> = ({ label, name }) => {
  const [field, meta] = useField(name);

  const key = `aea-form-cb-${name}`;

  return (
    <div className="aea-form-cb">
      <div className="aea-form-cb__container">
        <input
          className="aea-form-cb__checkbox"
          type="checkbox"
          name={name}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={field.value}
          id={key}
          checked={field.value}
        />
        <label htmlFor={key}>
          <span className="aea-form-cb__label">{label}</span>
        </label>
      </div>
      {meta.touched && meta.error && <FormikError name={name} />}
    </div>
  );
};

export default FormikToggle;
